export default __webpack_public_path__ + "static/aws-badge-fdaa7f4aa336e40174aabbb4077f51c5.png";